<template>
    <div class="business">
      <toast-message :message="errmsg" type="error" :isToastEnable="toast" @close="(val) => toast = val" />
  
      <div>
  
        <div class="row margin-t-s">
          <div class="datatable-outer-container">
            <data-table :columns="exemptTableColumns" :tableData="section10OtherData" :showinrow="true" :withForm="false"
              :showhistory="false" :showdelete="false" :showedit="false">
              <template v-slot:rowcontent="slotprops">
                <div>
                  <p v-if="slotprops.value.column.key == 'slno'">{{ slotprops.value.index + 1 }}</p>
                  <p v-if="slotprops.value.column.key == 'particulars'">
                  <!-- {{
                    slotprops.value.record.InvestmentComponentType ?
                      slotprops.value.record.InvestmentComponentType.abbreviation : slotprops.value.record.display_group
                  }} - -->
                   {{
                    slotprops.value.record['InvestmentComponentType.name'] ?
                      slotprops.value.record['InvestmentComponentType.name'] : slotprops.value.record.name
                  }}</p>
                  <p v-if="slotprops.value.column.key == 'exemption'">{{
                    (slotprops.value.record?
                      slotprops.value.record.exemption_value:
                      (Object.keys(slotprops.value.record.rule).length ? slotprops.value.record.rule.exemption_value : null)).toLocaleString("en-in")
                  }}
                  </p>
                  <p v-if="slotprops.value.column.key == 'planned'">
                    <txt type="number" :disable="slotprops.value.record.is_fbp_component == 'true'?true:slotprops.value.record.is_fbp_component == true ? true : false" :name="'explannedvalue' + slotprops.value.index"
                      v-model="section10OtherData[slotprops.value.index].planned"
                      v-validate="{ required: true, regex: /^[1-9]{1}[0-9]{6}$/ }" />
                    <!-- <span v-else>-</span> -->
                  </p>
                </div>
              </template>
            </data-table>
          </div>
        </div>
        <footer>
          <popup-bottom-container>
            <template slot="end">
              <btn-grp class="form-button">
                <btn text="Cancel" type="secondary" @click="goBack" />
                <btn :text="saveAsDraft ? 'Save as Draft' : 'Save'" type="primary" @click="submitData" v-if="itEnableValue"/>
              </btn-grp>
            </template>
          </popup-bottom-container>
        </footer>
      </div>
    </div>
  </template>
  
  <script>
  import { mapState, mapActions, mapGetters } from "vuex";
  
  export default {
    name: "deductionsUnderCdeu",
    props: {
    //   regimeType:{
    //     type: String
    //   },
      HraFormData:{
        type: Object
      },
    itEnableValue:{
      type: String,
      required: true
    },
      saveAsDraft: {
        type: Boolean
      }
    },
    data() {
      return {
        errmsg: "",
        data1: [],
        toast: false,
        showSuccessMsg: false,
        section10OtherData: [],
        exemptTableColumns: [
          {
            label: "SL No.",
            key: "slno"
          },
          {
            label: "Particulars",
            key: "particulars"
          },
          {
            label: "Salary Exemption",
            key: "exemption"
          },
          {
            label: "Planned",
            key: "planned"
          }
        ],
      };
    },
    computed: {
      le_id() {
        return this.$store.getters["onboard/legal_entities/legal_entity_ID"](
          this.$route.params.entity_index
        );
      },
    },
  
    mounted() {
      this.showSuccessMsg = false;
      this.load();
    },
  
    activated() {
      this.toast = false;
      this.errmsg = "";
      this.showSuccessMsg = false;
    },
  
    methods: {
      ...mapActions({
        getOrgLeList: "onboard/organization/getOrgLeIdList",
      }),
      load(){
        console.log(this.HraFormData);
         //console.log("Chapter VI A check...............",this.chapterVIA);
        this.section10OtherData = this.HraFormData.others ? this.HraFormData.others : []
        this.section10OtherData.map(element => {
          if(!element.hasOwnProperty("planned")){
            element.planned = 0;
          }
        })
            //console.log("after push data VI A",this.chapterData);
      },
  
      // Add here code for cancel button to hide popup By Bhushan 
      goBack() {
        this.$emit('back');
      },
      
      async submitData() {
        this.HraFormData.others = this.section10OtherData
        // let chapterData = [...this.chapterData, ...this.data1]
        this.$emit("section10Exemption", this.HraFormData);
        //this.$emit("data1", this.data1);
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  
  // .business {
  //   width: 100%;
  //   height: 100%;
  // }
  
  // .business .top-bar {
  //   height: auto;
  //   padding: 20px;
  //   background-color: #34c0be;
  //   display: flex;
  // }
  
  .search-container {
    width: auto;
  }
  
  .border-right-side {
    border-right: 2px solid #dddddd;
    padding-right: 0px;
  }
  
  .line-color {
    border-right: 2px solid #dddddd;
  }
  
  .img-float-right-side {
    float: right;
  }
  
  .tl-checkbox .container {
    font-size: 0.9rem;
  }
  
  .text-right-side {
    float: right;
  }
  
  .section-table {
    padding: 24px 0px;
  }
  
  .datatable-outer-container {
    width: 100%;
  }
          
  .datatable-outer-container table.datatable {
              width: 100%;
              border-collapse: collapse;
              margin: 0 auto;
              font-family: Montserrat;
              margin-bottom: 4px;
  }
          
          .datatable-outer-container table.datatable .header-row {
              background-color: white;
              height: 54px;
          }
          
          .datatable-outer-container table.datatable .header-row th {
              background-color: #f0f1f5;
              border-bottom: 1px solid #34c0be;
              padding: 6px 20px;
          }
          
          .datatable-outer-container table.datatable .header-row th .tl-checkbox {
              text-align: center;
          }
          
          .datatable-outer-container table.datatable .inactiveCols {
              opacity: 0.03;
              background-color: #a2a1a1;
          }
          
          .datatable-outer-container table.datatable .Editdeleteheader {
              background-color: #ffffff;
              -webkit-box-shadow: 0 2px 6px 0 rgba(52, 192, 190, 0.5);
              box-shadow: 0 2px 6px 0 rgba(52, 192, 190, 0.5);
          }
          
          .datatable-outer-container table.datatable .Editdeleteheader th {
              padding: 0 8px;
          }
          
          .datatable-outer-container table.datatable .Editdeleteheader th span {
              border-right: 1px solid #ececec;
              padding: 0px 18px 0px 15px;
              display: inline-block;
              vertical-align: middle;
          }
          
          .datatable-outer-container table.datatable .Editdeleteheader th span:first-child {
              padding: 10px 10px 7px 10px;
          }
          
          .datatable-outer-container table.datatable .Editdeleteheader th:last-of-type {
              text-align: right;
          }
          
          .datatable-outer-container table.datatable .Editdeleteheader th:last-of-type span {
              border-right: none;
              font-weight: 400;
              font-style: italic;
              position: relative;
          }
          
          .datatable-outer-container table.datatable .Editdeleteheader th:last-of-type span i {
              position: absolute;
              right: 10px;
              top: 2px;
          }
          
          .datatable-outer-container table.datatable .record-row {
              height: 60px;
              border-bottom: none;
          }
          
          .datatable-outer-container table.datatable .record-row:nth-child(odd) {
              background-color: #fff;
          }
          
          .datatable-outer-container table.datatable .record-row.selectedRecord {
              background-color: #E9F9F8;
              opacity: 0.9;
          }
          
          .datatable-outer-container table.datatable .record-row td {
              padding: 6px 8px;
              color: #646464;
              font-weight: 500;
          }
          
          .datatable-outer-container table.datatable .record-row td .tl-checkbox {
              text-align: center;
          }
          
          .datatable-outer-container table.datatable .record-row .actions {
              width: 10%;
              padding: 10px;
          }
          
          .datatable-outer-container table.datatable .record-row .row-item {
              padding: 6px 20px;
          }
          
          .datatable-outer-container table.datatable .record-row .row-item p {
              width: 100%;
              margin-bottom: 0px;
          }
          
          .datatable-outer-container table.datatable .record-row .action-img {
              display: inline-block;
              cursor: pointer;
              opacity: 0;
          }
          
          .datatable-outer-container table.datatable .record-row:hover .action-img {
              opacity: 1;
          }
  
  .inputbox{
     width: 149px;
    height: 35px;
    // width: 30%;
    padding: 4px;
    border: 1px solid #c6c9c8;
    border-radius: 4px;
    &:focus {
          outline: none;
          border: 2px solid #37c6c0;
      }
  }
  
  .inputbox-large{
    height: 35px;
    width: 30%;
    padding: 4px;
    border: 1px solid #c6c9c8;
    border-radius: 4px;
    &:focus {
          outline: none;
          border: 2px solid #37c6c0;
      }
  }
  
  
  </style>
  